<template>
  <div v-if="loaded" class="dropdown float-right mr-3">
    <button
      type="button"
      class="btn btn-secondary btn-sm dropdown-toggle"
      id="dropdownMenuOffset"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      {{ map[sort] }}
    </button>
    <div class="dropdown-menu" aria-labelledby="dropdownMenuOffset">
      <template v-for="(name, status) in map">
        <a v-if="status !== sort" class="dropdown-item" href="#" @click.prevent="sortBy(status)">
          {{ name }}
        </a>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data() {
    return {
      loaded: false,
      sort: 'active',
      map: {
        active: 'Aktivní',
        reserved: 'Rezervované',
        sold: 'Prodané',
        deactivated: 'Deaktivované',
        expired: 'Ukončené',
        all: 'Vše'
      }
    }
  },
  computed: {
    ...mapGetters({
      filters: 'filters/filters'
    })
  },
  mounted() {
    const parsed = queryString.parse(location.search, { arrayFormat: 'bracket' })
    if (parsed.sort) {
      this.setFilters(parsed)
    }

    setTimeout(() => {
      if (this.filters.sort) {
        this.sort = this.filters.sort
      }
      this.loaded = true
    }, 250)
  },
  methods: {
    ...mapActions({
      updateURL: 'filters/updateURL',
      setFilters: 'filters/setFilters'
    }),
    sortBy(status) {
      this.updateURL({ sort: status })
      window.location.reload(true)
    }
  }
}
</script>

<style lang="stylus" scoped>
  .dropdown
    button
      position relative
      top -3px
</style>
